<template lang='pug'>
  blue-layout(:user='user' :account='account' :biz='biz')
    template(v-slot:header)
      bf-header(title='Contact Us')

    #contact-us.view.with-header
      bf-wrapper.positioned.content
        bf-overlay#confirmation-overlay.back(
          v-show='step'
          @close='step = 0'
        )
          h4.centered-text {{ $t("Your Inquiry Has Been Sent!")}}
          bf-divider.card
          bf-flex.buttons.space-between
            bf-button.clear.small(@click.native='back')
              template(v-slot:text) {{ $t("Back to Last Visited")}}
            bf-button.clear.small(@click.native='another')
              template(v-slot:text) {{ $t("Send Another Inquiry")}}

        article(v-show='!step')

          header {{ $t("Have any questions? We'd love to hear from you.")}}
          main
            base-card.front
              h5.centered-text {{ $t("Contact Us")}}
              form(
                ref='form'
                @submit.prevent='inquire'
              )
                label(v-if='!inquiry.account.username') {{$t("Name *")}}
                bf-input.block.basic(v-if='!inquiry.account.username')
                  input(
                    v-model='inquiry.account.username'
                    type='text'
                    :disabled='inquiry.account.username'
                  )

                label(v-if='!inquiry.account.name') {{$t("Account")}}
                bf-input.block.basic(v-if='!inquiry.account.name')
                  input(
                    v-model='inquiry.account.name'
                    type='text'
                    :disabled='inquiry.account.name'
                  )

                label(v-if='!inquiry.biz.name') {{$t("Company Name")}}
                bf-input.block.basic(v-if='!inquiry.biz.name')
                  input(
                    v-model='inquiry.biz.name'
                    type='text'
                    :disabled='inquiry.biz.name'
                  )

                label(v-if='!inquiry.account.email') {{$t("Email *")}}
                bf-input.block.basic(v-if='!inquiry.account.email')
                  input(
                    v-model='inquiry.account.email'
                    type='text'
                    :disabled='inquiry.account.email'
                  )

                label {{$t("Your Message")}}
                textarea(
                    v-model='inquiry.message'
                  )

                .centered-text
                  bf-button.wide(type='submit')
                    template( v-slot:text ) {{$t("Submit Request")}}

                bf-link.large(:to='{ path: "/help-center" }')
                  template(v-slot:text) {{$t("Visit Help Center")}}

          footer
            bf-flex.centered
              bf-flex.column.emails
                a(href='mailto:info@bluefaucet.com')
                  img(src='@/assets/public_ui_email-icon.png')
                  span INFO@BLUEFAUCET.COM
                a(href='mailto:jobs@bluefaucet.com')
                  img(src='@/assets/public_ui_email-icon.png')
                  span JOBS@BLUEFAUCET.COM
                a(href='mailto:sales@bluefaucet.com')
                  img(src='@/assets/public_ui_email-icon.png')
                  span SALES@BLUEFAUCET.COM
                a(href='mailto:invest@bluefaucet.com')
                  img(src='@/assets/public_ui_email-icon.png')
                  span INVEST@BLUEFAUCET.COM
</template>

<script>
  import { db } from '@/main'
  import { View } from '@/mixins/view'
  import BaseCard from '@/components/base-card'

  export default {
    name: 'contact-us.view',

    mixins: [View],

    components: {
      BaseCard
    },

    data() {
      return {
        inquiry: { account: this.account || {}, biz: this.biz || {} },
        step: 0
      }
    },

    watch: {
      account(curr, prev) {
        if ( curr.id ) this.inquiry.account = curr
      },

      biz(curr, prev) {
        if ( curr & curr.id ) this.inquiry.biz = curr
      }
    },

    methods: {
      inquire() {
        db.collection('inquiries').add(this.inquiry).then( () => this.step = 1 )
      },

      back() {
        this.$router.go(-1)
      },

      another() {
        this.inquiry.message = ''
        this.step = 0
      }
    }
  }
</script>

<style scoped lang='stylus'>
  #confirmation-overlay
    margin-top 16px

  .bf-input
    margin-bottom 10px
  .bf-link
    margin-top 20px
  textarea
    border solid 1px rgba(0 0 0 0.1)
    border-radius 5px
    padding 8px
    margin-bottom 10px
    width 98%
  article
    header
      text-align center

    main
      margin-top 12px
      h5
        background orange
        padding 8px 8px 24px 8px
        color white
        font-weight bold
      form
        background white
        padding 16px
        position relative
        z-index 1
        top -16px
        a
          color blue
        .submit
          margin 12px 0 24px 0

    footer
      margin-top 16px
      font-weight bold
      .emails
        align-items flex-start
      a
        margin 8px 0

        img
          margin-right 7px
          bottom -4px
          position relative
</style>
